import { ApiClientInstance } from '@shared/api';
import { InsuranceAssetType } from '@entities/investments';

import {
  TGoldLastPriceResponse,
  TGoldOrderRequest,
  TGoldPreorderRequest,
  TGoldPreorderResponse,
} from './type';

export const goldLivePrice = (assetType: InsuranceAssetType) => {
  return ApiClientInstance.get<TGoldLastPriceResponse>(`v2/investment/Insurance/${assetType}/live`);
};

export const goldPreorder = (data: TGoldPreorderRequest) => {
  return ApiClientInstance.post<TGoldPreorderRequest, TGoldPreorderResponse>(
    `v2/investment/Insurance/${InsuranceAssetType.Gold}/preorder`,
    data
  );
};

export const goldOrder = (data: TGoldOrderRequest) => {
  return ApiClientInstance.post<TGoldOrderRequest, string>(
    `v2/investment/Insurance/${InsuranceAssetType.Gold}/orders`,
    data
  );
};
